import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// 브라우저 캐시 무효화를 위한 빌드 타임스탬프
const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIMESTAMP || Date.now();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA Service Worker 등록
serviceWorkerRegistration.register();
